import * as React from 'react'

import { INTRODUCTION, ELEMENTARY_AND_MIDDLE_SCHOOL_ELA, } from './constants'

const NextButton = ({ tour, onLastSlide, goToNextSlide, setTour, }) => {
  if (tour !== INTRODUCTION && onLastSlide) {
    return <span />
  }

  let handleClick = goToNextSlide
  let copy = 'Next'

  if (tour === INTRODUCTION && onLastSlide) {
    handleClick = () => { setTour(ELEMENTARY_AND_MIDDLE_SCHOOL_ELA) }
    copy = 'General overview'
  }

  return (
    <button
      className="quill-button large contained green focus-on-light"
      onClick={handleClick}
      type="button"
    >{copy}</button>
  )
}

export default NextButton
